import React, { useState, useEffect, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { useSelector, useDispatch } from 'react-redux';
import { StoreState } from '../store';
import { motion, useAnimation } from 'framer-motion';
import Typography from '@material-ui/core/Typography';
import { login } from '../store/session/sessionActions';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(3),
    maxWidth: 320,
    margin: '100px auto',
  },
  btnSendForm: {
    marginTop: 16,
  },
  helperText: {
    color: theme.palette.secondary.dark,
    minHeight: 24,
  },
}));

const selector = ({ sessionState }: StoreState) => ({
  loading: sessionState.loadingLogin || sessionState.logged,
  error: sessionState.error,
  failed: sessionState.failed,
});

export default function Login() {
  const classes = useStyles();
  const paperAnimation = useAnimation();
  const dispatch = useDispatch();

  const { loading, error, failed } = useSelector(selector);

  const [form, setForm] = useState({
    email: '',
    password: '',
  });

  const [helperText, setHelperText] = useState('');

  const animateFormError = useCallback(() => {
    paperAnimation.start({ x: [15, -15, 15, 0] }, { duration: 0.3 });
  }, [paperAnimation]);

  useEffect(() => {
    setTimeout(() => {
      paperAnimation.start({ opacity: 1, y: 0 });
    }, 500);
  }, [paperAnimation]);

  useEffect(() => {
    if (failed) {
      setHelperText(failed);
      animateFormError();
    } else if (error) {
      setHelperText('Houve um problema, tente mais tarde.');
    }
  }, [error, failed, animateFormError]);

  const onChangeForm = (e: any) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmitForm = (e: any) => {
    e.preventDefault();
    if (!form.email || !form.password) {
      setHelperText('Digite o e-mail e a senha.');
      animateFormError();
      return;
    }
    setHelperText('');
    dispatch(login(form.email, form.password));
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      exit={{ opacity: 0, scale: 0.5 }}
      animate={paperAnimation}
    >
      <Paper className={classes.paper}>
        <Typography align="center" color="primary" variant="h6">
          <div
            style={{
              display: 'flex',
              marginBottom: 16,
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img src="/logo.png" width="150" height="150" alt="logo" />
          </div>
          <p style={{ marginTop: -40, fontWeight: 400 }}> igreja nas nuvens</p>
        </Typography>
        <form onChange={onChangeForm} onSubmit={onSubmitForm}>
          <Typography
            className={classes.helperText}
            align="center"
            children={helperText}
          />
          <TextField
            fullWidth
            name="email"
            label="E-mail"
            value={form.email}
            margin="normal"
          />
          <TextField
            fullWidth
            name="password"
            type="password"
            label="Senha"
            value={form.password}
            margin="normal"
          />
          <Button
            fullWidth
            className={classes.btnSendForm}
            type="submit"
            color="primary"
            disabled={loading}
            variant="contained"
            children={loading ? 'Aguarde' : 'Entrar'}
          />
        </form>
      </Paper>
    </motion.div>
  );
}
